<template>
  <div class="image-editor" v-loading="loading" :style="$store.state.ui.appStyle">
    <div class="topLeft">
      <el-button-group>
        <el-button round size="small" @click="close">
          <el-image :style="{ width: btnSize, height: btnSize }" :src="require('@/assets/render/svg/close.svg')"></el-image>
        </el-button>
        <el-button round size="small" @click="revert">
          <el-image :style="{ width: btnSize, height: btnSize }" :src="require('@/assets/render/svg/revert.svg')"></el-image>
        </el-button>
      </el-button-group>
    </div>
    <div class="topCenter">
      <div style="text-align: center;">
      </div>
      <div v-if="selectedType === 'bg'" style="text-align: center;margin-top: 40px;display: flex;">
        <el-button round size="small" type="text" @click="rotateLeft" style="color: #515151;">
          <el-image style="height: 3vh;width: 3vh;" :src="require('@/assets/render/svg/rotate_left.svg')"></el-image>
          旋转
        </el-button>
        <el-button round size="small" type="text" @click="flip" style="color: #515151;">
          <el-image style="height: 3vh;width: 3vh;" :src="require('@/assets/render/svg/flip.svg')"></el-image>
          翻转
        </el-button>
      </div>
    </div>
    <div class="topRight">
      <el-button round size="small" style="background-color: #ffc343;" @click="done">完成</el-button>
    </div>
    <div class="bottomCenter" v-if="$store.state.ui.os.isPC">
      <div :class="{ 'hidden': selectedType !== 'text' || activeKeyboard }">
        <text-props ref="textprops" @change="changeText" />
      </div>
      <div v-if="selectedType === 'bg'">
        <div style="position: relative;width: 500px;height: 100px;left: 50%;transform: translateX(-50%);">
          <div style="position: absolute;" :class="{ 'gost': rulerType !== 'rotation' }">
            <div>{{ innerAngle }}°</div>
            <ruler
              ref="rulerRotation"
              style="width: 500px;"
              top-border
              :height="100"
              :min="-45"
              :max="45"
              :default-value="innerAngle"
              :gap="10"
              :point-width="4"
              :value-gap="1" @change="changeRotation">
            </ruler>
          </div>
          <div style="position: absolute;" :class="{ 'gost': rulerType !== 'zoom' }">
            <div>{{ innerZoom }}%</div>
            <ruler
              ref="rulerZoom"
              style="width: 500px;"
              top-border
              :height="100"
              :min="5"
              :max="200"
              :default-value="innerZoom"
              :gap="10"
              :point-width="4"
              :value-gap="1" @change="changeZoom">
            </ruler>
          </div>
          <div style="position: absolute;" :class="{ 'gost': rulerType !== 'scale' }">
            <div>{{innerScale * 10}}%</div>
            <ruler
              ref="rulerScale"
              style="width: 500px;"
              top-border
              :height="100"
              :min="-9"
              :max="10"
              :default-value="innerScale"
              :gap="10"
              :point-width="4"
              :value-gap="1" @change="changeScale">
            </ruler>
          </div>
        </div>
        <el-button style="color: #515151;" round size="small" @click="rulerType = 'rotation'" :class="{ 'activeButton': rulerType === 'rotation' }">
          角度
        </el-button>
        <el-button style="color: #515151;" round size="small" @click="rulerType = 'zoom' " :class="{ 'activeButton': rulerType === 'zoom' }">
          大小
        </el-button>
        <el-checkbox style="margin-left: 12px;" v-model="isRepeat" @change="toggleRepeat">平铺</el-checkbox>
      </div>
      <div v-if="selectedType === 'image'" style="margin-bottom: 15px;display: flex;align-items: end;">
        <el-button style="margin-top: 50px;" @click="showMatting">去背景</el-button>
        <template v-if="$store.state.ui.os.isPC">
          <input type="color" style="margin-left: 12px;" class="color-trigger" v-model="innerColor" @input="changeColor" @blur="confirmColor">
        </template>
        <template v-else>
          <el-color-picker :show-alhpa="false" color-format="hex" style="margin-left: 12px;" v-model="innerColor" @active-change="changeColorActive"></el-color-picker>
        </template>
      </div>
    </div>
    <div class="bottomCenter" v-else>
      <div :class="{ 'hidden': selectedType !== 'text' || activeKeyboard }">
        <text-props ref="textprops" @change="changeText" />
      </div>
      <div v-if="selectedType === 'bg'">
        <div style="position: relative;width: 90vw;height: 10vh;overflow: hidden;">
          <div style="position: absolute;" :class="{ 'gost': rulerType !== 'rotation' }">
            <div>{{ innerAngle }}°</div>
            <ruler
              ref="rulerRotation"
              style="width: 90vw;"
              top-border
              :height="100"
              :min="-45"
              :max="45"
              :default-value="innerAngle"
              :gap="10"
              :point-width="4"
              :value-gap="1" @change="changeRotation">
            </ruler>
          </div>
          <div style="position: absolute;" :class="{ 'gost': rulerType !== 'zoom' }">
            <div>{{ innerZoom }}%</div>
            <ruler
              ref="rulerZoom"
              style="width: 90vw;"
              top-border
              :height="100"
              :min="5"
              :max="200"
              :default-value="innerZoom"
              :gap="10"
              :point-width="4"
              :value-gap="1" @change="changeZoom">
            </ruler>
          </div>
          <div style="position: absolute;" :class="{ 'gost': rulerType !== 'scale' }">
            <div>{{innerScale * 10}}%</div>
            <ruler
              ref="rulerScale"
              style="width: 90vw;"
              top-border
              :height="100"
              :min="-9"
              :max="10"
              :default-value="innerScale"
              :gap="10"
              :point-width="4"
              :value-gap="1" @change="changeScale">
            </ruler>
          </div>
        </div>
        <el-button style="color: #515151;" round size="small" @click="rulerType = 'rotation'" :class="{ 'activeButton': rulerType === 'rotation' }">
          角度
        </el-button>
        <el-button style="color: #515151;" round size="small" @click="rulerType = 'zoom' " :class="{ 'activeButton': rulerType === 'zoom' }">
          大小
        </el-button>
        <el-checkbox style="margin-left: 12px;" v-model="isRepeat" @change="toggleRepeat">平铺</el-checkbox>
      </div>
      <div v-if="selectedType === 'image'" style="margin-bottom: 15px;display: flex;">
        <el-button @click="showMatting">去背景</el-button>
        <template v-if="$store.state.ui.os.isPC">
          <input type="color" style="margin-left: 12px;" class="color-trigger" v-model="innerColor" @input="changeColor" @blur="confirmColor">
        </template>
        <template v-else>
          <el-color-picker :show-alhpa="false" color-format="hex" style="margin-left: 12px;" v-model="innerColor" @active-change="changeColorActive"></el-color-picker>
        </template>
      </div>
      <div class="toolsPhone" v-if="!activeKeyboard">
        <el-row v-for="(tool, index) in tools" :key="'tool' + index">
          <template v-if="tool.name === 'Logo'">
            <el-popover placement="top" :width="popWidth" v-model="activeHistory" trigger="manual">
              <image-history id="imageHistory" ref="imageHistory" @select="selectHistory" />
              <el-button slot="reference" style="border: 1px solid lightgray;border-radius: 50%;margin-right: 12px;" size="small" circle type="text" @click="changeTool(tool)">
                <el-image :src="require(`@/assets/render/svg/${tool.img}`)" style="width: 2vh;height: 2vh;display: block;margin: 0 auto;"></el-image>
              </el-button>
            </el-popover>
          </template>
          <template v-else>
            <el-button style="border: 1px solid lightgray;border-radius: 50%;margin-right: 12px;" size="small" circle type="text" @click="changeTool(tool)">
              <el-image :src="require(`@/assets/render/svg/${tool.img}`)" style="width: 2vh;height: 2vh;display: block;margin: 0 auto;"></el-image>
            </el-button>
          </template>
        </el-row>
      </div>
    </div>
    <div class="tools" v-if="$store.state.ui.os.isPC">
      <el-row v-for="(tool, index) in tools" :key="'tool' + index">
        <template v-if="tool.name === 'Logo'">
          <el-popover placement="right" :width="390" v-model="activeHistory">
            <div slot="reference" class="tool" @click="changeTool(tool)">
              <el-image :src="require(`@/assets/render/svg/${tool.img}`)" style="width: 2vh;height: 2vh;display: block;margin: 0 auto;"></el-image>
              <div :class="{ 'smallText': tool.name.length > 6 }" style="font-size: small;font-color: #515151;">{{ tool.name }}</div>
            </div>
            <image-history id="imageHistory" ref="imageHistory" @select="selectHistory" />
          </el-popover>
        </template>
        <template v-else>
          <div class="tool" @click="changeTool(tool)">
            <el-image :src="require(`@/assets/render/svg/${tool.img}`)" style="width: 2vh;height: 2vh;display: block;margin: 0 auto;"></el-image>
            <div :class="{ 'smallText': tool.name.length > 6 }" style="font-size: small;font-color: #515151;">{{ tool.name }}</div>
          </div>
        </template>
      </el-row>
    </div>
    <template v-if="$store.state.ui.os.isPC">
      <div class="content">
        <image-editor-content ref="content" @select="onSelect" @setZoom="onSetZoom" @setRotation="onSetRotation" @setScale="onSetScale" />
      </div>
      <div v-if="selectedItem" style="position: absolute;top: 15px;left: 50%;transform: translate(-50%);display: flex;">
        <div class="input-wrapper" @click="showPositionDialog">
          <div class="input-prepend">位置</div>
          <div class="input-content">{{selectedItemPosition}}</div>
        </div>
        <div class="input-wrapper" style="margin-left: 5px;" @click="showSizeDialog">
          <div class="input-prepend">尺寸</div>
          <div class="input-content">{{selectedItemSize}}</div>
        </div>
        <div class="input-wrapper" style="margin-left: 5px;" @click="showRotationDialog">
          <div class="input-prepend">角度</div>
          <div class="input-content" style="width: 20px;">{{selectedItemRotation}}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="contentPhone" :style="{ height: contentPhoneHeight }">
        <image-editor-content ref="content" @select="onSelect" @setZoom="onSetZoom" @setRotation="onSetRotation" @setScale="onSetScale" />
      </div>
      <div v-if="selectedItem" style="min-width: 200px;position: absolute;z-index: 1;top: 50px;left: 50%;transform: translate(-50%);">
        <div class="input-wrapper" style="font-size: 12px;" @click="showPositionDialog">
          <div class="input-prepend">位置</div>
          <div class="input-content" style="width: 120px;">{{selectedItemPosition}}</div>
        </div>
        <div class="input-wrapper" style="font-size: 12px;" @click="showSizeDialog">
          <div class="input-prepend">尺寸</div>
          <div class="input-content">{{selectedItemSize}}</div>
        </div>
        <div class="input-wrapper" style="font-size: 12px;" @click="showRotationDialog">
          <div class="input-prepend">角度</div>
          <div class="input-content">{{selectedItemRotation}}</div>
        </div>
      </div>
    </template>
    <input ref="inputBG" type="file" class="hidden" @change="onChangeBG" @click="onClick">
    <input ref="inputLogo" type="file" class="hidden" @change="onChangeLogo" @click="onClick">
    <matting v-if="activeMatting" ref="matting" @close="activeMatting = false" @done="onDoneMatting" />
    <el-dialog
      v-model="activeSizeDialog"
      title="Size"
      :width="sizeDialogSize"
    >
      <div style="text-align: center;display: flex;flex-direction: column;">
        <div style="margin-bottom: 12px;">
          <span style="margin-right: 12px;">Width</span>
          <el-input-number v-model="inputSizeWidth" :min="1" :max="999999" @change="changeSizeWidth" :size="!$store.state.ui.os.isPC ? 'small' : 'default'" />
          <span style="margin-left: 12px;">mm</span>
        </div>
        <div>
          <span style="margin-right: 12px;">Height</span>
          <el-input-number v-model="inputSizeHeight" :min="1" :max="999999" @change="changeSizeHeight" :size="!$store.state.ui.os.isPC ? 'small' : 'default'" />
          <span style="margin-left: 12px;">mm</span>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="activeSizeDialog = false">Cancel</el-button>
          <el-button type="primary" @click="confirmSize"
            >Confirm</el-button
          >
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="activePositionDialog"
      title="Position"
      :width="sizeDialogSize"
    >
      <div style="text-align: center;display: flex;flex-direction: column;">
        <div style="margin-bottom: 12px;">
          <span style="margin-right: 12px;">center</span>
          <el-input-number v-model="inputPositionX" :min="-999999" :max="999999" :size="!$store.state.ui.os.isPC ? 'small' : 'default'" />
          <span style="margin-left: 12px;">mm</span>
        </div>
        <div>
          <span style="margin-right: 12px;">bottom</span>
          <el-input-number v-model="inputPositionY" :min="-999999" :max="999999" :size="!$store.state.ui.os.isPC ? 'small' : 'default'" />
          <span style="margin-left: 12px;">mm</span>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="activePositionDialog = false">Cancel</el-button>
          <el-button type="primary" @click="confirmPosition"
            >Confirm</el-button
          >
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="activeRotationDialog"
      title="Rotation"
      :width="sizeDialogSize"
    >
      <div style="text-align: center;display: flex;flex-direction: column;">
        <div style="margin-bottom: 12px;">
          <span style="margin-right: 12px;"></span>
          <el-input-number v-model="inputRotation" :min="-999999" :max="999999" :size="!$store.state.ui.os.isPC ? 'small' : 'default'" />
          <span style="margin-left: 12px;">°</span>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="activeRotationDialog = false">Cancel</el-button>
          <el-button type="primary" @click="confirmRotation"
            >Confirm</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Ruler from './Ruler.vue'
import ImageEditorContent from './ImageEditorContent.vue'
import { debounce } from 'debounce'
import TextProps from './TextProps.vue'
import ConvertFile from '@/utils/ConvertFile.js'
import { Message } from 'element-ui'
import { setItem } from '@/utils/Utils.js'
import Matting from './Matting.vue'
import ImageHistory from './ImageHistory.vue'
import moment from 'dayjs'

export default {
  components: {
    Ruler,
    ImageEditorContent,
    TextProps,
    Matting,
    ImageHistory
  },
  data () {
    return {
      activeMatting: false,
      innerColor: '#ffffff',
      loading: false,
      rulerScale: null,
      rulerRotation: null,
      rulerZoom: null,
      cropData: null,
      rulerType: 'rotation',
      textprops: null,
      selectedType: '',
      selected: null,
      activeHistory: false,
      btnSize: window.innerHeight * 0.015 + 'px',
      tools: [{
        name: 'Text',
        img: 'text.svg'
      }, {
        name: 'Logo',
        img: 'logo.svg'
      }, {
        name: 'Background',
        img: 'background.svg'
      }, {
        name: 'No Background',
        img: 'transparent.svg'
      }],
      popWidth: window.innerWidth - 10,
      activeSizeDialog: false,
      activePositionDialog: false,
      activeRotationDialog: false,
      inputSizeWidth: 0,
      inputSizeHeight: 0,
      lastChangeType: 'width',
      inputPositionX: 0,
      inputPositionY: 0,
      inputRotation: 0,
      isRepeat: false
    }
  },
  computed: {
    activeKeyboard () {
      if (this.$store.state.ui.os.isIOS) return false
      if (this.$store.state.ui.os.isPC) return false
      return this.$store.state.ui.keyboard
    },
    contentPhoneHeight () {
      return (window.innerHeight - 170 - 170) + 'px'
    },
    selectedItem () {
      return this.$store.state.crop.selected
    },
    innerZoom () {
      return this.$store.state.editor.zoom
    },
    innerAngle () {
      return this.$store.state.editor.rotation
    },
    innerScale () {
      return this.$store.state.editor.scale
    },
    sizeDialogSize () {
      if (!this.$store.state.ui.os.isPC) {
        return '80%'
      } else {
        return '30%'
      }
    },
    selectedItemPosition () {
      if (this.selectedItem) {
        return `${Math.round(this.selectedItem._x)} mm x ${Math.round(this.selectedItem._y)} mm`
      } else {
        return ''
      }
    },
    selectedItemRotation () {
      if (this.selectedItem) {
        return `${Math.round(this.selectedItem.angle)}°`
      } else {
        return ''
      }
    },
    selectedItemSize () {
      if (this.selectedItem) {
        return `${Math.round(this.selectedItem._width)} mm x ${Math.round(this.selectedItem._height)} mm`
      } else {
        return ''
      }
    }
  },
  methods: {
    toggleRepeat () {
      this.$refs.content.toggleRepeat()
      this.rulerType = 'zoom'
    },
    showRotationDialog () {
      if (!this.selectedItem) return
      this.inputRotation = Math.round(this.selectedItem.angle)
      this.activeRotationDialog = true
    },
    showPositionDialog () {
      if (!this.selectedItem) return
      this.inputPositionX = Math.round(this.selectedItem._x)
      this.inputPositionY = Math.round(this.selectedItem._y)
      this.activePositionDialog = true
    },
    confirmRotation () {
      this.activeRotationDialog = false
      if (!this.$refs.content) return
      this.$refs.content.rotateItem(this.inputRotation)
    },
    confirmPosition () {
      this.activePositionDialog = false
      if (!this.$refs.content) return
      this.$refs.content.moveItem({
        x: this.inputPositionX,
        y: this.inputPositionY
      })
    },
    async changeTool (tool) {
      tool = tool.name.toLowerCase()
      if (tool === 'background') {
        if (this.$refs.inputBG) {
          this.$refs.inputBG.click()
        }
      } else if (tool === 'text') {
        this.addText()
      } else if (tool === 'logo') {
        this.activeHistory = true
        await this.$nextTick()
        this.$store.state.ui.initImageHistory = true
      } else if (tool === 'no background') {
        if (this.$refs.content) {
          this.$refs.content.changeBG(null)
          if (this.selectedType === 'bg') {
            this.selected = null
            this.selectedType = ''
          }
        }
      }
    },
    showSizeDialog () {
      if (!this.selectedItem) return
      this.inputSizeWidth = Math.round(this.selectedItem._width)
      this.inputSizeHeight = Math.round(this.selectedItem._height)
      this.activeSizeDialog = true
      this.lastChangeType = 'width'
    },
    changeSizeWidth () {
      if (!this.selectedItem) return
      this.inputSizeHeight = Math.round(this.selectedItem._height / this.selectedItem._width * this.inputSizeWidth)
      this.lastChangeType = 'width'
    },
    changeSizeHeight () {
      if (!this.selectedItem) return
      this.inputSizeWidth = Math.round(this.selectedItem._width / this.selectedItem._height * this.inputSizeHeight)
      this.lastChangeType = 'height'
    },
    confirmSize () {
      this.activeSizeDialog = false
      if (!this.$refs.content) return
      if (this.lastChangeType === 'width') {
        this.$refs.content.resizeItem(this.inputSizeWidth / this.selectedItem._width)
      } else {
        this.$refs.content.resizeItem(this.inputSizeHeight / this.selectedItem._height)
      }
    },
    onDoneMatting (src) {
      if (!this.$refs.content) return
      const name = moment().format('YYYYMMDDHHmmss') + '.png'
      this.activeMatting = false
      this.$refs.content.matting({
        name,
        src
      })
      this.$store.state.ui.addImageHistory = {
        name,
        src
      }
    },
    async showMatting () {
      if (!this.selected || this.selected._type !== 'image') return
      this.activeMatting = true
      await this.$nextTick()
      if (this.$refs.matting) {
        this.$refs.matting.load(this.selected.sprite.texture.baseTexture.resource.url)
      }
    },
    async onSelect (target) {
      // console.log('onSelect', target?.entity)
      if (target && target._type === 'image') {
        this.innerColor = target.entity.color || '#ffffff'
      }
      this.activeHistory = false
      if (target) {
        this.selected = target
        this.selectedType = target._type
      } else {
        this.selected = null
        this.selectedType = ''
      }
      await this.$nextTick()
      if (target && target._type === 'text') {
        if (this.$refs.textprops) {
          this.$refs.textprops.init(target)
        }
      }
    },
    onSetZoom () {
      if (this.$refs.rulerZoom) {
        this.$refs.rulerZoom.setValue(this.$store.state.editor.zoom, true)
      }
    },
    onSetRotation () {
      if (this.$refs.rulerRotation) {
        this.$refs.rulerRotation.setValue(this.$store.state.editor.rotation, true)
      }
    },
    onSetScale () {
      if (this.$refs.rulerScale) {
        this.$refs.rulerScale.setValue(this.$store.state.editor.scale, true)
      }
    },
    clearProps () {
      if (this.$refs.content) {
        this.$refs.content.clear()
      }
      this.$store.state.editor.zoom = 100
      this.$store.state.editor.rotation = 0
      this.$store.state.editor.scale = 0
      this.rulerType = 'rotation'
      this.loading = true
      this.onSelect(null)
    },
    close () {
      this.clearProps()
      this.$emit('close')
    },
    async revert () {
      this.clearProps()
      this.$emit('revert')
    },
    async done () {
      if (!this.$refs.content) return
      const { src, crop } = await this.$refs.content.crop()
      this.$emit('crop', {
        src,
        crop,
        name
      })
      await this.$refs.content.done()
      const indexCrop = this.$store.state.editor.currentLayer.props.globalProps.indexOf('crop')
      if (indexCrop > -1) {
        const cropKey = this.$store.state.editor.currentLayer.props.globalKeys[indexCrop]
        const newKey = `${this.$store.state.editor.product.name}_${cropKey}_crops`
        await setItem(newKey, JSON.stringify(this.$store.state.crop.crops))
        // console.log('保存裁切数据1', newKey, this.$store.state.crop.crops)
      } else {
        const newKey = `${this.$store.state.editor.product.name}_${this.$store.state.editor.inprint.type}_${this.$store.state.editor.currentLayer.props.label}_crops`
        await setItem(newKey, JSON.stringify(this.$store.state.crop.crops))
        // console.log('保存裁切数据2', newKey, this.$store.state.crop.crops)
      }
      this.close()
    },
    rotateLeft () {
      if (!this.$refs.content) return
      this.$refs.content.rotateLeft()
    },
    flip () {
      if (!this.$refs.content) return
      this.$refs.content.flip()
    },
    addText () {
      if (!this.$refs.content) return
      this.$refs.content.addText()
    },
    onChangeBG (e) {
      const file = e.target.files[0]
      if (file) {
        this.loading = true
        const convert = new ConvertFile(file, async (e) => {
          if (e.msg === 'success') {
            if (this.$refs.content) {
              await this.$refs.content.changeBG(e.data)
            }
            this.loading = false
            this.isRepeat = false
          } else {
            console.log('转换失败', e.msg, e.data)
            // ElMessage.error('Failed to import image')
            Message({
              message: 'Failed to import image',
              type: 'error'
            })
            this.loading = false
          }
        })
        convert.start()
      }
    },
    selectHistory (data) {
      if (this.$refs.content) {
        this.$refs.content.addLogo(data.src, null, data.name)
      }
    },
    onChangeLogo (e) {
      const file = e.target.files[0]
      if (file) {
        this.loading = true
        const convert = new ConvertFile(file, async (e) => {
          if (e.msg === 'success') {
            if (this.$refs.content) {
              await this.$refs.content.addLogo(e.data)
            }
            this.loading = false
          } else {
            console.log('转换失败', e.msg, e.data)
            Message({
              message: 'Failed to import image',
              type: 'error'
            })
            // ElMessage.error('Failed to import image')
            this.loading = false
          }
        })
        convert.start()
      }
    },
    onClick (e) {
      e.target.value = null
    },
    changeRotationFunc (val) {
      this.$store.state.editor.rotation = val
      if (!this.$refs.content) return
      this.$refs.content.rotate(val)
    },
    changeRotation (val) {
      debounce(this.changeRotationFunc(val), 1)
    },
    changeZoomFunc (val) {
      this.$store.state.editor.zoom = val
      if (!this.$refs.content) return
      this.$refs.content.zoom(val)
    },
    changeZoom (val) {
      debounce(this.changeZoomFunc(val), 1)
    },
    changeScaleFunc (val) {
      this.$store.state.editor.scale = val
      if (!this.$refs.content) return
      this.$refs.content.scale(1 + val * 0.1)
    },
    changeScale (val) {
      debounce(this.changeScaleFunc(val), 1)
    },
    changeTextFunc (e) {
      if (!this.$refs.content) return
      this.$refs.content.changeText(e)
    },
    changeText (val) {
      debounce(this.changeTextFunc(val), 1)
    },
    async load (cropdata) {
      if (!this.$refs.content) return
      this.cropData = cropdata
      this.loading = true
      await this.$refs.content.load(cropdata)

      // 初始化尺子
      if (this.$store.state.crop.crops.bg) {
        this.$store.state.editor.zoom = this.$store.state.crop.crops.bg.zoom || 100
        this.$store.state.editor.rotation = this.$store.state.crop.crops.bg.rotation || 0
        this.$store.state.editor.scale = this.$store.state.crop.crops.bg.scale || 0
        this.isRepeat = this.$store.state.crop.crops.bg.isRepeat
      } else {
        this.isRepeat = false
      }

      if (this.$refs.rulerZoom) {
        this.$refs.rulerZoom.setValue(this.$store.state.editor.zoom, true)
      }
      if (this.$refs.rulerRotation) {
        this.$refs.rulerRotation.setValue(this.$store.state.editor.rotation, true)
      }
      if (this.$refs.rulerScale) {
        this.$refs.rulerScale.setValue(this.$store.state.editor.scale, true)
      }
      this.loading = false
    },
    confirmColor () {
      this.$refs.content.confirmColor()
    },
    changeColorActive (val) {
      this.$refs.content.changeImgColor(val)
    },
    changeColor () {
      if (!this.$refs.content) return
      this.$refs.content.changeImgColor(this.innerColor)
    }
  }
}
</script>

<style lang="scss" scoped>
.image-editor {
  position: absolute;
  width: 100vw;
  z-index: 999;
  top: 0;
  // left: 0;
  background-color: white;
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
.topLeft {
  z-index: 998;
  position: absolute;
  top: 0;
  left: 0;
  margin: 15px;
}
.topCenter {
  z-index: 998;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  margin: 15px;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}
.topRight {
  z-index: 998;
  position: absolute;
  top: 0;
  right: 0;
  margin: 15px;
}
.bottomCenter {
  z-index: 998;
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
.gost {
  top: -9999px;
}
.tools {
  z-index: 998;
  left: 0;
  margin-left: 15px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  position: absolute;
}
.toolsPhone {
  z-index: 998;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  margin-top: 12px;
}
.tool {
  width: 7vh;
  height: 7vh;
  border-radius: 10px;
  border: 1px solid #d3d3f3;
  margin-bottom: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  cursor: pointer;
}
.content {
  z-index: 997;
  position: absolute;
  width: calc(100vw - 110px - 110px);
  height: calc(100vh - 110px - 150px);
  left: 110px;
  top: 110px;
}
.contentPhone {
  z-index: 997;
  position: absolute;
  width: calc(100vw - 12px - 12px);
  left: 12px;
  top: 170px;
}
.activeButton {
  background-color: #c3c3c3;
}
.zero {
  transform: scale(0);
}
.smallText {
  transform: scale(0.85);
}
.input-wrapper {
  display: flex;
  font-size: 14px !important;
  height: 37px;
}
.input-prepend {
  padding: 10px 10px;
  border: 1px solid #dcdfe6;
  border-right: none;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #f5f7fa;
  color: gray;
  font-size: small;
}
.input-content {
  padding: 10px 10px;
  border: 1px solid #dcdfe6;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  color: gray;
  cursor: pointer;
  font-size: small;
}

.isRepeat {
  background-color: #007aff !important;
  color: white !important;
}
</style>
